<template>
    <div class="app-quote-text-checkboxes">
        <div class="text-checkboxes-wrap">
            <label v-for="item in items" :class="{'checked': newValue.indexOf(item.value) !== -1}">
                <span class="text-checkboxes-circle">
                    <input type="checkbox"
                           :value="item.value"
                           v-model="newValue"
                           @change="onInput">

                    <span class="icon" v-html="newValue.indexOf(item.value) !== -1 ? $icon(item.icon_checked) : $icon(item.icon)"></span>
                </span>

                <span class="label">{{ item.label }}</span>
            </label>
        </div>

        <p class="message" v-if="message">{{ message }}</p>
    </div>
</template>

<script>

    export default {

        props: {
            message: String,
            items: Array,
            value: [String, Boolean, Array]
        },

        data() {
            return {
                newValue: this.value
            }
        },

        watch: {
            value() {
                this.newValue = this.value;
            }
        },

        methods: {

            onInput() {
                this.$emit('input', this.newValue);
                this.$emit('change', this.newValue);
            }

        }

    }

</script>

<style lang="scss" scoped>

    .app-quote-text-checkboxes {
        position: relative;

        .text-checkboxes-wrap {
            display: flex;
            align-items: center;
        }

        label {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            flex-direction: column;
            margin: 0 45px;

            .text-checkboxes-circle {
                position: relative;
                width: 156px;
                height: 156px;
                border: solid 1px $medium-gray;
                border-radius: 50%;
                transition: .2s ease-in-out;

                .icon {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }

            &.checked {
                .text-checkboxes-circle {
                    border: 1px solid $primary-blue;
                }

                span.label {
                    color: $primary-blue;
                }
            }

            span.label {
                font-size: 25px;
                font-weight: $font-light;
                line-height: 1.32;
                margin-top: 5px;
                color: $black;
                transition: color .2s ease-in-out;
            }
        }


        input {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            opacity: 0;
            z-index: 2;
            cursor: pointer;
        }

        .message {
            font-size: 1em;
            margin: 25px 0 0;
            color: $error-red;
            font-weight: $font-normal;
        }

    }

</style>
